export default {
  // Auth pages
  'signIn.title': '登录',
  'signIn.subtitle': '欢迎回到 PackVerse',
  'signIn.email': '邮箱地址',
  'signIn.password': '密码',
  'signIn.forgotPassword': '忘记密码？',
  'signIn.button': '登录',
  'signIn.noAccount': '还没有账户？',
  'signIn.signUpLink': '注册',
  'signIn.or': '或使用以下方式继续',
  'signIn.google': 'Google',
  'signIn.facebook': 'Facebook',
  'signIn.error.invalid': '邮箱或密码错误',
  'signIn.error.noSupabase': '服务器连接未配置，请联系支持。',
  'signIn.error.generic': '发生错误，请重试。',

  'signUp.title': '创建账户',
  'signUp.subtitle': '免费加入 PackVerse',
  'signUp.fullName': '姓名',
  'signUp.email': '邮箱地址',
  'signUp.password': '密码',
  'signUp.passwordHint': '至少 6 个字符',
  'signUp.confirmPassword': '确认密码',
  'signUp.button': '创建账户',
  'signUp.hasAccount': '已经有账户？',
  'signUp.signInLink': '登录',
  'signUp.or': '或使用以下方式注册',
  'signUp.google': 'Google',
  'signUp.facebook': 'Facebook',
  'signUp.error.passwordMatch': '两次输入的密码不一致',
  'signUp.error.weakPassword': '密码至少需要 6 个字符',
  'signUp.error.noSupabase': '服务器连接未配置，请联系支持。',
  'signUp.error.generic': '注册时发生错误，请重试。',
  'signUp.success': '账户创建成功！请查收邮件以完成验证。',
  'signUp.terms': '注册即表示你同意我们的服务条款与隐私政策。',

  'logout': '退出登录',
  'myAccount': '我的账户',
  'dashboard': '仪表盘',

  'customerAccount': '客户账户',
  'adminBadge': '管理员',
  'myQuotes': '我的报价单',
  'myOrders': '我的订单',
  'aiPreviews': 'AI 后加工预览',
  'savedProducts': '收藏产品',
  'companyProfile': '公司资料',
  'shippingAddress': '收货地址',
  'accountSettings': '账户设置',
  'adminConsole': '管理后台',
};